import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sharepoint-dev',
  templateUrl: './sharepoint-dev.component.html',
  styleUrls: ['./sharepoint-dev.component.css']
})
export class SharepointDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/sharepoint-dev/sharepoint-dev.component.ts